import React, { forwardRef } from 'react';
import { ModalContent } from './ModalContent';
import type { ModalContentProps } from './ModalContent';
import { ModalOverlay } from './ModalOverlay';
import { ModalPortal } from './ModalPortal';

interface ModalContainerProps extends ModalContentProps {
  withPortal?: boolean;
}

export const ModalContainer = forwardRef<HTMLDivElement, ModalContainerProps>(
  ({ withPortal = true, ...contentProps }, forwardedRef) => {
    return withPortal ? (
      <ModalPortal>
        <ModalOverlay />
        <ModalContent ref={forwardedRef} {...contentProps} />
      </ModalPortal>
    ) : (
      <>
        <ModalOverlay />
        <ModalContent ref={forwardedRef} {...contentProps} />
      </>
    );
  },
);
